import { Divider, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { CardContent, Typography, Collapse } from "@mui/material";
import { Card } from "@mui/material";
import ProposedTeamCard from "./ProposedTeamCard";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { TeamList } from "./LeagueSignUp";
import { League } from "../WeekAtAGlance/IndividualTournament";
import IndividualPlayerCard from "./IndividualPlayerCard";

/*interface Team {
  id: number;
  name: string;
  pending: boolean;
}*/

function AvailableTeams({
  title,
  teams,
  areTeamsPending,
  tournamentId,
  devPort,
  reloadTeams,
  managerMode,
  clubId,
  league,
}: {
  title: string;
  teams: TeamList;
  areTeamsPending: boolean;
  tournamentId: number;
  devPort: string;
  reloadTeams: () => void;
  managerMode: number;
  clubId: number;
  league: League;
}) {
  const [expanded, setExpanded] = useState(true);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card sx={{ mb: 4 }} elevation={12}>
      <CardContent>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            fontWeight="bold"
            color={
              title.includes("Declined")
                ? "secondary"
                : title.includes("Pending")
                ? "warning"
                : "primary"
            }
          >
            {title}
          </Typography>
          <IconButton
            onClick={handleExpandClick}
            sx={{
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s",
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
        </div>
        <Divider sx={{ mb: 2 }} />
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Grid
            container
            spacing={2}
            columns={12}
            sx={{ mb: (theme) => theme.spacing(2) }}
          >
            {Object.keys(teams).map((teamId) => (
              <Grid key={teamId} size={{ xs: 12, sm: 6, lg: 3 }}>
                <ProposedTeamCard
                  title={teams[teamId].teamName}
                  teamHandicap={teams[teamId].teamHandicap}
                  pendingTeam={areTeamsPending}
                  teamDetails={teams[teamId]}
                  teamId={teamId}
                  devPort={devPort}
                  tournamentId={tournamentId}
                  reloadTeams={reloadTeams}
                  managerMode={managerMode}
                />
              </Grid>
            ))}
          </Grid>
        </Collapse>
        {title.includes("Pending") && (
          <IndividualPlayerCard
            devPort={devPort}
            clubId={clubId}
            league_id={league.tournament_id}
            managerMode={managerMode}
            refreshProps={Object.keys(teams).length}
          />
        )}
      </CardContent>
    </Card>
  );
}

export default AvailableTeams;
